export default __webpack_public_path__ + "static/media/EG.0d60885a.svg";